import { render, staticRenderFns } from "./Unaccepted.vue?vue&type=template&id=42d61d08&scoped=true&"
import script from "./Unaccepted.vue?vue&type=script&lang=js&"
export * from "./Unaccepted.vue?vue&type=script&lang=js&"
import style0 from "./Unaccepted.vue?vue&type=style&index=0&id=42d61d08&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42d61d08",
  null
  
)

export default component.exports